// extracted by mini-css-extract-plugin
export default {"spinnerDiv":"Spinner-module_spinnerDiv-qNv3a","spinner":"Spinner-module_spinner-4EJns","fadeIn":"Spinner-module_fadeIn--idnZ","rotate360":"Spinner-module_rotate360-kByc+"};